export default __webpack_public_path__ + "static/media/button arrow-1.39a7c651.png";